import { useState, useEffect } from 'react';
import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { loginRequest } from "../authConfig";
import { useLocalStorage } from 'usehooks-ts';
import axios from '../axiosConfig';
const API_URL = process.env.REACT_APP_API_URL || "";
const PROFILE_IMAGE = 'PROFILE_IMAGE';
const PROFILE_IMAGE_DATA = 'PROFILE_IMAGE_DATA';

const useProfileData = (fetchProfileImage = true) => {
  const [isFetching, setIsFetching] = useState(false);
  const [token, setToken] = useState();
  const [profileImage, setProfileImage] = useLocalStorage(PROFILE_IMAGE, '/DefaultProfile.png');
  const [profileImageData, setProfileImageData] = useLocalStorage(PROFILE_IMAGE_DATA, null);
  const [userName, setuserName] = useState();
  const [userEmail, setuserEmail] = useState();
  const [isAdmin, setIsAdmin] = useState(false);
  const { instance, accounts } = useMsal();
  const firstAccount = accounts[0];

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const apiResponse = await instance.acquireTokenSilent({
          ...loginRequest,
          account: firstAccount
        });

        axios.defaults.headers.common['Authorization'] = `Bearer ${apiResponse.accessToken}`;
        
        setToken(firstAccount.idToken);
        setuserName(apiResponse.account.name);
        setuserEmail(apiResponse.account.username);


        if (fetchProfileImage && profileImageData === null) {
          try {
            const graphResponse = await instance.acquireTokenSilent({
              scopes: ['User.Read'],
              account: firstAccount
            });

            const graphEndpoint = 'https://graph.microsoft.com/v1.0/me/photo/$value';
            const imageResponse = await fetch(graphEndpoint, {
              headers: {
                Authorization: `Bearer ${graphResponse.accessToken}`,
              },
            });

            if (imageResponse.ok) {
              const blob = await imageResponse.blob();
              const reader = new FileReader();
              reader.readAsDataURL(blob);
              reader.onload = () => {
                setProfileImage(reader.result);
                setProfileImageData({ data: blob });
              };
            }
          } catch (graphError) {
            console.error('Error fetching profile image:', graphError);
            setProfileImage('/DefaultProfile.png');
            setProfileImageData(null);
          }
        }
      } catch (error) {
        console.error('Error in profile data fetch:', error);
        
        // Manejo del error de MFA expirado (AADSTS50078)
        if (error instanceof InteractionRequiredAuthError || 
            (error.errorCode === 'interaction_required') || 
            (error.message && error.message.includes('AADSTS50078'))) {
          
          console.log('MFA expirado. Redirigiendo al flujo de autenticación interactiva...');
          

          instance.acquireTokenRedirect({
            ...loginRequest,
            account: firstAccount
          }).catch(redirectError => {
            console.error('Error al iniciar redirección:', redirectError);
          });
        }
        
        setProfileImage('/DefaultProfile.png');
        setProfileImageData(null);
      }
    };
    const fetchAdminStatus = async () => {
    if (!userEmail) return;

    try {
      const encodedEmail = encodeURIComponent(userEmail);
      const response = await axios.get(`${API_URL}/Userspermisions/user/${encodedEmail}/is-admin`);
      setIsAdmin(response.data.isAdmin);
    } catch (error) {
      console.error("Error checking admin status:", error);
      setIsAdmin(false);
    }
  };
    fetchAdminStatus()
    if (firstAccount && !isFetching) {
      setIsFetching(true);
      fetchProfileData();
      setIsFetching(false);
    }
  }, [instance, firstAccount, fetchProfileImage, profileImageData, setProfileImage, setProfileImageData, userEmail]);

  return { token, profileImage, userName, userEmail, profileImageData, isAdmin };
};

export default useProfileData;